import React from "react";
import { useMeasure } from "react-use";
import classNames from "classnames";
import useDarkMode from "../../hooks/useDarkMode";

const Footer = () => {
  const [ref, { height }] = useMeasure();

  const root = document.documentElement;
  root.style.setProperty("--footer-height", `${height}px`);

  const { darkModeStatus } = useDarkMode();

  return (
    <footer ref={ref} className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <span className="fw-light">Copyright © 2022 - Version 1.0.0</span>
          </div>
          <div className="col-auto d-none">
            <a
              href="/"
              className={classNames("text-decoration-none", {
                "link-dark": !darkModeStatus,
                "link-light": darkModeStatus,
              })}
            >
              <small className="fw-bold">
                Powered By Xeonplex Software Limited
              </small>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
